import { SADisplay, SADefaultFlow } from '@chegg-wt/core/constants/site'

export interface SuperAuthIFrameModalData {
  display: SADisplay
  defaultFlow: SADefaultFlow
  origin: SuperAuthIframeOrigin
  hardGate?: boolean
  alwaysParticipate?: boolean
}

export enum SuperAuthIframeOrigin {
  CREATE_CITATION_HOMEPAGE = 'create-citation-homepage',
  CHECK_PAPER_HOMEPAGE = 'check-paper-homepage',
  SOURCE_BANNER_PAGE = 'source-banner-page',
  VIEW_PAGE_EXPORT = 'view-page-export',
  CITATION_FORM_PAGE = 'citation-form-page',
  OIM_VIEWPAGE = 'oim-view-page',
  CFC_VIEWPAGE_EXIT_GUEST = 'cfc-viewpage-exit-popup-guest',
  ACCOUNT_STYLE_GATE_VIEWPAGE = 'account-style-gate-viewpage',
  REDESIGNED_UNLOCK_MODAL = 'redesigned-unlock-modal',
}
